export default "__VITE_ASSET__B6E0M9ls__"